import { render, staticRenderFns } from "./HotelStatus.vue?vue&type=template&id=08de36ee&scoped=true"
import script from "./HotelStatus.vue?vue&type=script&lang=js"
export * from "./HotelStatus.vue?vue&type=script&lang=js"
import style0 from "./HotelStatus.vue?vue&type=style&index=0&id=08de36ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08de36ee",
  null
  
)

export default component.exports